import { ToolsContainerProps } from '../../../../../../components/Container'
import { nameActions } from '../../info'

export const toolsPrintPdf = (
  id: string,
  handleOnClick: any
): ToolsContainerProps => ({
  name: 'Imprimir',
  to: `/commercial/contracts/view/${id}`,
  icon: nameActions.print.icon,
  handleOnClick: handleOnClick
})
